module.exports = __webpack_public_path__ + "img/7806ff1e-8bf1-4cac-8767-9d26fb67b937.40810864.jpg";